import { render, staticRenderFns } from "./BI.vue?vue&type=template&id=e43f39d4&"
import script from "./BI.vue?vue&type=script&lang=js&"
export * from "./BI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports